import React from 'react';
import {
  executionProviderLabel,
  isKnownExecutionProvider,
  normalizeExecutionProvider,
} from '../baking/executionProviders';

/**
 * Compact provider label for project/job surfaces.
 * Never labels an unknown or Maya record as Unity.
 */
function ExecutionProviderBadge({ provider, className = '' }) {
  const key = normalizeExecutionProvider(provider);
  const label = executionProviderLabel(provider);
  const known = isKnownExecutionProvider(provider);
  const tone =
    key === 'unity' ? 'primary' : key === 'maya' ? 'info' : 'secondary';
  return (
    <span
      className={`badge text-bg-${tone} ${className}`.trim()}
      title={known ? undefined : `Unrecognized execution provider: ${key || 'empty'}`}
      data-testid="execution-provider-badge"
      data-provider={key || ''}
    >
      {label}
    </span>
  );
}

export default ExecutionProviderBadge;
